export class EasyChannelHelper {
  /**
   * Process socket payload for user - show them something...
   * @param {Object} payload - key must be one of [modal, notification, function, firework] only !
   * */
  doSomething(payload) {
    Object.keys(payload).forEach(type => {
      switch (type) {
        case "modal":
          this.#showModal(payload.modal);
          break;
        case "notification":
          window.EASY.notify(payload.notification);
          break;
        case "function":
          eval(payload.function);
          break;
        case "firework": {
          const container = document.querySelector("#ajax-modal");
          window.EASY.fireworks.fire(container);
          break;
        }
      }
    });
  }

  /**
   * open jQuery dialog window
   * @param {Object} dialog
   * @param {Array} dialog.buttons - see jQuery dialog button
   * @param {String} dialog.message - content of modal
   * @param {String} dialog.title
   * */
  #showModal(dialog) {
    (dialog.buttons || []).forEach(element => {
      if (element.click === "close") {
        // On close window dialog stop Firework too
        element.click = () => {
          if (window.firework) {
            window.firework.stop();
          }
          $(this).dialog("close");
        };
      }
    });
    const $dialog = $("#ajax-modal");
    $dialog.html(dialog.message);
    window.showModal("ajax-modal", "40%");
    $dialog.dialog("option", {
      buttons: dialog.buttons,
      title: dialog.title,
    });
  }
}
